var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EuiContainer',[_c('EuiGridRow',{staticClass:"mx-0 mt-2"},[_c('resultInvalidMails')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }